const payments = [
  // {
  //   text: "M-Pesa",
  //   enable: true,
  //   type: "MPESA_KENYA",
  //   merchantId: 9,
  //   img: "../assets/images/home/mpasa.png",
  //   checkPrecedence: (phone) => {
  //     return true;
  //   },
  // },
  {
    text: "MTN",
    enable: false,
    type: "MTN_UGANDA",
    merchantId: 10,
    img: "../assets/images/home/MTN.png",
    checkPrecedence: (phone) => {
      let phoneHeader = parseInt(phone.substring(0, 3), 10);
      if (
        (phoneHeader >= 700 && phoneHeader <= 706) ||
        (phoneHeader >= 750 && phoneHeader <= 759) ||
        (phoneHeader >= 740 && phoneHeader <= 749)
      ) {
        return true;
      }
      return false;
    },
  },
  {
    text: "Airtel",
    enable: false,
    merchantId: 10,
    type: "AIRTEL_UGANDA",
    img: "../assets/images/home/airtel_money.png",
    checkPrecedence: (phone) => {
      let phoneHeader = parseInt(phone.substring(0, 3), 10);
      if (
        (phoneHeader >= 730 && phoneHeader <= 739) ||
        (phoneHeader >= 750 && phoneHeader <= 756) ||
        phoneHeader === 762 ||
        (phoneHeader >= 780 && phoneHeader <= 789) ||
        (phoneHeader >= 100 && phoneHeader <= 108)
      ) {
        return true;
      }
      return false;
    },
  },
  {
    text: "M-Pesa",
    enable: true,
    type: "MPESA_KENYA",
    merchantId: 35,
    img: "../assets/images/home/mpasa.png",
    checkPrecedence: (phone) => {
      let phoneHeader = parseInt(phone.substring(0, 3), 10);
      if (
        (phoneHeader >= 700 && phoneHeader <= 709) ||
        (phoneHeader >= 710 && phoneHeader <= 729) ||
        (phoneHeader >= 740 && phoneHeader <= 743) ||
        (phoneHeader >= 745 && phoneHeader <= 746) ||
        phoneHeader === 748 ||
        (phoneHeader >= 757 && phoneHeader <= 759) ||
        (phoneHeader >= 768 && phoneHeader <= 769) ||
        (phoneHeader >= 790 && phoneHeader <= 799) ||
        (phoneHeader >= 110 && phoneHeader <= 117)
      ) {
        return true;
      }

      return false;
    },
  },
  {
    text: "Tarspay",
    enable: true,
    type: "Tarspay",
    merchantId: 38,
    img: "",
    minWithdrawAmount: 50000,
    checkPrecedence: (phone) => {
      return false;
    },
  },

  {
    text: "PAY F",//futurepay
    enable: true,
    type: "futurepay",
    merchantId: 51,
    img: "",
    minWithdrawAmount: 50000,
    checkPrecedence: (phone) => {
      return false;
    },
  },
  {
    text: "al_MPESA",//almarapay
    enable: true,
    type: "MPESA_KEN",
    merchantId: 54,
    img: "../assets/images/home/mpasa.png",
    checkPrecedence: (phone) => {
      let phoneHeader = parseInt(phone.substring(0, 3), 10);
      if (
        (phoneHeader >= 700 && phoneHeader <= 709) ||
        (phoneHeader >= 710 && phoneHeader <= 729) ||
        (phoneHeader >= 740 && phoneHeader <= 743) ||
        (phoneHeader >= 745 && phoneHeader <= 746) ||
        phoneHeader === 748 ||
        (phoneHeader >= 757 && phoneHeader <= 759) ||
        (phoneHeader >= 768 && phoneHeader <= 769) ||
        (phoneHeader >= 790 && phoneHeader <= 799) ||
        (phoneHeader >= 110 && phoneHeader <= 117)
      ) {
        return true;
      }

      return false;
    },
  },

  {
    text: "al_Airtel",//almarapay
    enable: true,
    type: "AIRTEL_KEN",
    merchantId: 54,
    img: "../assets/images/home/airtel_money.png",
    checkPrecedence: (phone) => {
      let phoneHeader = parseInt(phone.substring(0, 3), 10);
      if (
        (phoneHeader >= 730 && phoneHeader <= 739) ||
        (phoneHeader >= 750 && phoneHeader <= 756) ||
        phoneHeader === 762 ||
        (phoneHeader >= 780 && phoneHeader <= 789) ||
        (phoneHeader >= 100 && phoneHeader <= 108)

      ) {
        return true;
      }
      return false;
    },
  },

  {
    text: "PAY CL",//cradlevoices
    enable: true,
    type: "cradlevoices",
    merchantId: 61,
    isHideDepositPageBlock: false,//显示充值
    isHideWithdraw: false,//隐藏提款
    img: "../assets/images/wallet/wallet_M_A.png",
    minWithdrawAmount: 20000,
    checkPrecedence: (phone) => {
      return false;
    },
  },

  // {
  //   text: "PAY IN",//inpay
  //   enable: true,
  //   type: "inpay",
  //   merchantId: 58,
  //   isHideDepositPageBlock: true,//隐藏充值
  //   isHideWithdraw: false,//显示提款
  //   img: "",
  //   checkPrecedence: (phone) => {
  //     return true;
  //   },
  // },
  {
    text: "M-Pesa",//inpay
    enable: true,
    type: "8",
    merchantId: 58,
    isHideDepositPageBlock: false,//显示充值
    isHideWithdraw: true,//隐藏提款
    img: "../assets/images/home/mpasa.png",
    minWithdrawAmount: 20000,
    checkPrecedence: (phone) => {
      let phoneHeader = parseInt(phone.substring(0, 3), 10);
      if (
        (phoneHeader >= 700 && phoneHeader <= 709) ||
        (phoneHeader >= 710 && phoneHeader <= 729) ||
        (phoneHeader >= 740 && phoneHeader <= 743) ||
        (phoneHeader >= 745 && phoneHeader <= 746) ||
        phoneHeader === 748 ||
        (phoneHeader >= 757 && phoneHeader <= 759) ||
        (phoneHeader >= 768 && phoneHeader <= 769) ||
        (phoneHeader >= 790 && phoneHeader <= 799) ||
        (phoneHeader >= 110 && phoneHeader <= 117)
      ) {
        return true;
      }

      return false;
    },
  },
];

const codes = [
  // {
  //   codeId : "JAZZCASH",
  //   codeText : "JAZZCASH",
  // },
  // {
  //   codeId : "EASYPAISA",
  //   codeText : "EASYPAISA",
  // },
  {
    codeId: "001",
    codeText: "MPS",
    codeMsg: "MPS",
  },
  {
    codeId: "002",
    codeText: "airtel",
    codeMsg: "airtel",
  },
  {
    codeId: "003",
    codeText: "AIRTZA",
    codeMsg: "AIRTZA",
  },
  {
    codeId: "004",
    codeText: "SAFKEN",
    codeMsg: "SAFKEN",
  },

];

const codes2 = [
  {
    codeId: "8",
    codeText: "M-Pesa",
    codeMsg: "M-Pesa",
  },
  {
    codeId: "9",
    codeText: "Airtel",
    codeMsg: "Airtel",
  },

];
export default {
  payments: payments.filter((payment) => payment.enable),
  codes: codes,
  codes2: codes2,
};
